<template>
  <div>
    <!-- 达人投稿视频 -->
    <div v-if="formKey === 'star_task_author_videos'">
      <div class="flex items-center">
        <el-button v-if="!formItem.isPreview" type="primary" @click="openStarTaskAuthorVideos(formItem)">添加投稿视频</el-button>
        <i v-if="Object.keys(formItem.value || {}).length && !formItem.isPreview" class="el-icon-success app-check-icon-success ml-10" />
      </div>
      <div v-if="formItem.isPreview">-</div>
      <el-dialog
        title="达人投稿视频配置"
        :visible.sync="formItem.is_open"
        :close-on-click-modal="false"
        :append-to-body="true"
        :modal-append-to-body="true"
        width="1200px"
      >
        <star-task-author-videos v-if="formItem.is_open" :form-item="formItem" :init-ops="initOps" />
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="formItem.is_open = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="confirmStarTaskAuthorVideos(formItem)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-if="formKey === 'image_ids'">
      <el-button v-if="!formItem.isPreview" size="mini" type="primary" @click="formItem.is_open = true">添加产品主图</el-button>
      <material-list :is-preview="formItem.isPreview" :material-data="formItem.value" :material-limit="formItem.limit" />
      <!-- 素材弹框 -->
      <material-box
        v-if="formItem.is_open"
        :is-open="formItem.is_open"
        type="image"
        :temp-material="null"
        :material-restriction="formItem.material_restriction"
        @confirm="(m_data) => materialConfirm({ material_data: m_data, form_item: formItem })"
        @cancel="formItem.is_open = false"
      />
    </div>
    <div v-if="formKey === 'anchor_id'">
      <el-button v-if="!formItem.isPreview" type="primary" @click="formItem.is_open = true">选择原生锚点</el-button>
      <div v-if="formItem.value.result_value.length">
        <div>
          <span class="mr-20">{{ formItem.value.result_value[0].advertiser_id }}</span>
          <span class="mr-20">{{ formItem.value.result_value[0].channel_alias }}</span>
          <span>{{ getOptionByValue(formItem.value.result_value[0].options, formItem.value.result_value[0].value)?.label || '-' }}</span>
        </div>
      </div>
      <el-dialog
        title="原生锚点配置"
        :visible.sync="formItem.is_open"
        :close-on-click-modal="false"
        :append-to-body="true"
        :modal-append-to-body="true"
        width="800px"
      >
        <anchor-id v-if="formItem.is_open" ref="anchor-id-ref" :form-item="formItem" :init-ops="initOps" />
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="formItem.is_open = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="confirm(formItem)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { component_props } from '@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/model/props';
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

export default {
  components: {
    'material-box': () => import('@/components/material-box'),
    'material-list': () => import('./components/material-list/index.vue'),
    'anchor-id': () => import('./components/anchor-id/index.vue'),
    'star-task-author-videos': () => import('./components/star-task-author-videos/index.vue'),
  },
  mixins: [data_sharing_mixin],
  props: {
    ...component_props,
  },
  methods: {
    /**
     * 素材弹窗确认
     * @param {Object} data
     * @param {Object[]} material_data 素材数据
     * @param {Object[]} material_data 表单配置项
     */
    materialConfirm({ material_data, form_item }) {
      form_item.is_open = false;

      if (material_data.length === 0) {
        return;
      }

      if ((material_data.length + form_item.value.length) > form_item.limit) {
        this.$message.warning(`素材超出上限${form_item.limit}个！`);
        return;
      }

      form_item.value.push(...material_data);
      this.$parent.$parent.$parent.$parent.$parent.validateField('product_info.children.image_ids.value');
    },
    /**
     * 根据值获取选项
     * @param {Object[]} options 选项
     * @param {number|string} val 值
     * @returns {Object}
     */
    getOptionByValue(options, val) {
      return options.find(({ value }) => value === val) || {};
    },
    /**
     * 配置弹窗确认
     * @param form_item 表单项
     * @returns {void}
     */
    confirm(form_item) {
      const result = this.$refs['anchor-id-ref']?.getAssignResult() || [];
      const is_valid = result.length && result.every(({ type, value }) => type && value);
      if (is_valid) {
        form_item.value.result_value = result;
        form_item.is_open = false;
        form_item?.on?.change?.(form_item.value);
        this.$parent.$parent.$parent.validateField('anchor_id.value');
      } else {
        this.$message.warning('请填写完整所有配置');
      }
    },
    /**
     * 打开投稿视频
     * @param form_item 表单项
     * @returns {void}
     */
    openStarTaskAuthorVideos(form_item) {
      form_item.assignSelection = JSON.parse(JSON.stringify(form_item.value));
      form_item.filter_config_backup = JSON.parse(JSON.stringify(form_item.filter_config));
      form_item.is_open = true;
    },
    /**
     * 投稿视频配置弹窗确认
     * @param form_item 表单项
     * @returns {void}
     */
    confirmStarTaskAuthorVideos(form_item,) {
      const { min_selection_count } = form_item;
      const result = JSON.parse(JSON.stringify(form_item.assignSelection));
      const { config: { init_ops: { advertiser_ids }}} = this.local_sharing_data.getFormContext();
      const is_valid = advertiser_ids.every(advertiser_id => result[advertiser_id]?.length >= min_selection_count);
      if (is_valid) {
        form_item.value = JSON.parse(JSON.stringify(form_item.assignSelection));
        form_item.filter_config = JSON.parse(JSON.stringify(form_item.filter_config_backup));
        form_item.is_open = false;
        form_item?.on?.change?.(form_item.value);
        this.$parent.$parent.$parent.validateField('star_task_author_videos.value');
      } else {
        this.$message.warning(`每个账户至少添加${min_selection_count}条投稿视频`);
      }
    },
  },
};
</script>
